import Button from 'components/field/Button';

import { faAppStoreIos, faGooglePlay } from '@fortawesome/free-brands-svg-icons';

import * as S from './OTOFlex.styled';

const DownloadConfig = (props) => {
	const { closePopper } = props;

	return (
		<S.PopperContainer>
			<Button
				component="a"
				icon={faAppStoreIos}
				href="https://apps.apple.com/us/app/oto-driver/id1535770290"
				target="_blank"
				label="otoFlexAppStore"
				variant="borderless"
				fullWidth
				onClick={() => {
					closePopper();
				}}
			/>
			<Button
				component="a"
				icon={faGooglePlay}
				href="https://play.google.com/store/apps/details?id=com.tryoto.otodriverapp"
				target="_blank"
				label="otoFlexPlayStore"
				variant="borderless"
				fullWidth
				onClick={() => {
					closePopper();
				}}
			/>
		</S.PopperContainer>
	);
};

export default DownloadConfig;
